module.exports = __webpack_public_path__ + "img/lagani_sahid.40184d6c.jpg";